// extracted by mini-css-extract-plugin
module.exports = {"custom-slider":"custom-slider"};